import React from "react";
import DecorativeSquares from "../../components/ui/DecorativeSquares";
import { useNavigate } from "react-router-dom";
import Card from "../../components/Cards/Card";
import { FaArrowLeft } from "react-icons/fa";

const SubsHistory = () => {
  const navigate = useNavigate();

  const cardsData = [
    {
      id: 1,
      varient: "growth",
      title: "Starter Plan",
      Order: "20",
      date: "09 September 2025 02:40 pm",
    },
    {
      id: 2,
      varient: "growth",
      title: "Growth Plan",
      Order: "20",
      date: "08 August 2025 10:40 pm",
    },
  ];

  return (
    <section className="relative max-w-7xl xl:max-w-6xl 2xl:max-w-5xl mx-auto px-4 md:px-6 py-10 pb-32 md:pb-10">
      <DecorativeSquares />

      {/* ================= HEADER ================= */}
      <div className="flex items-center justify-between bg-white px-5 md:px-6 py-4 rounded-2xl shadow-sm">
        <button
          onClick={() => navigate("/profile/subscription-plan")}
          className="p-2 rounded-full hover:bg-gray-100 transition"
        >
          <FaArrowLeft size={20} />
        </button>

        <h1 className="text-lg md:text-2xl font-semibold text-gray-900">
          Subscription History
        </h1>

        {/* spacer */}
        <div className="w-10" />
      </div>

      {/* ================= PLANS ================= */}
      <div className="mt-12 flex justify-center">
        <div className="w-full">
          <div className="grid grid-cols-1 md:grid-cols-2   gap-8">
            {cardsData.map((data) => (
              <Card
                key={data.id}
                title={data.title}
                date={data.date}
                varient={data.varient}
                orders={data.Order}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SubsHistory;
